var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.invoiceUrl || 'http://' + _vm.fpurl,"target":"_blank"}},[_vm._v("预览")]),_c('iframe',{attrs:{"src":_vm.invoiceUrl || 'http://' + _vm.fpurl,"width":"100%","height":"100%","frameborder":"1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }